import { DataType, DetectedPdfField } from '@/interfaces';

export type ClientSignDataType = DataType;

const VALIDATED_TYPES: ReadonlySet<ClientSignDataType> =
	new Set<ClientSignDataType>([
		'FIRST_NAME',
		'LAST_NAME',
		'FULL_NAME',
		'ADDRESS_1',
		'ADDRESS_2',
		'FULL_ADDRESS',
		'STATE',
		'CITY',
		'ZIP_CODE',
		'EMAIL',
		'PHONE',
	]);

export const isValidatedClientDataType = (
	dataType: ClientSignDataType
): boolean => VALIDATED_TYPES.has(dataType);

const normalizeLabel = (value: string): string =>
	value.toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();

export const mockDataTypeForField = (
	field: DetectedPdfField
): ClientSignDataType => {
	if (field.fieldType === 'signature') return 'SIGNATURE';

	const haystack = normalizeLabel(`${field.label} ${field.fieldName}`);

	if (/\bemail\b/.test(haystack)) return 'EMAIL';
	if (/\bphone\b|\bmobile\b|\btelephone\b/.test(haystack)) return 'PHONE';
	if (/\bzip\b|\bpostal\b/.test(haystack)) return 'ZIP_CODE';
	if (/\bcity\b/.test(haystack)) return 'CITY';
	if (/\bstate\b/.test(haystack)) return 'STATE';
	if (/\baddress\s*2\b|\baddr(?:ess)?\s*2\b|\bsuite\b|\bapt\b/.test(haystack)) {
		return 'ADDRESS_2';
	}
	if (/\bfull\s*address\b/.test(haystack)) return 'FULL_ADDRESS';
	if (/\baddress\b|\bstreet\b/.test(haystack)) return 'ADDRESS_1';
	if (/\bfirst\s*name\b/.test(haystack)) return 'FIRST_NAME';
	if (/\blast\s*name\b|\bsurname\b/.test(haystack)) return 'LAST_NAME';
	if (
		/\bfull\s*name\b|\bprint\s*name\b|\bclaimant\s*name\b|\bname\b/.test(
			haystack
		)
	) {
		return 'FULL_NAME';
	}

	return 'DO_NOT_VALIDATE';
};
